const isNamesListSite = (): boolean =>
  !!window.location.hostname.match(/nameslist/) ||
  (window.location.hostname === 'localhost' &&
    process.env?.REACT_APP_NAME_OF_WEBSITE === 'NamesList');

export default isNamesListSite;
